import React, { FunctionComponent, ReactNode } from "react";
import { HiOutlineCheck } from "react-icons/hi";

interface JobFormCompletedProps {
  // Optional action rendered below the message (e.g. the "Preview your response" button).
  action?: ReactNode;
  // Copy overrides for layouts that reuse this screen (the off-campus request form). Defaults are the job form's.
  title?: string;
  message?: string;
}

/** Compact job-form completion screen (no oversized illustration / whitespace). */
const JobFormCompleted: FunctionComponent<JobFormCompletedProps> = ({
  action,
  title = "Submitted Successfully!",
  message = "Thank you! Your response has been recorded."
}) => (
  <div className="flex flex-col items-center text-center gap-3 py-4">
    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-1 text-primary-6 text-2xl">
      <HiOutlineCheck />
    </span>
    <h2 className="m-0 text-xl font-semibold text-neutral-12">{title}</h2>
    <p className="m-0 text-sm text-neutral-9">{message}</p>
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default JobFormCompleted;
